import { CommonCarrierService } from '@savgroup-front-common/core/api';

import createPackingCommand from '@/api/Carrier/createPackingCommand';
import getCarrierDimensionSpecificationsQuery from '@/api/Carrier/getCarrierDimensionSpecificationsQuery';
import getCarrierLabelUrlByPackingParcelIdQuery from '@/api/Carrier/getCarrierLabelUrlByPackingParcelIdQuery';
import getPackingBySellerByStatusQuery from '@/api/Carrier/getPackingBySellerByStatusQuery';
import getWaitingPackingProductsBySellerQuery from '@/api/Carrier/getWaitingPackingProductsBySellerQuery';
import uploadExternalCarrierDepositLabelCommand from '@/api/Carrier/uploadExternalCarrierDepositLabelCommand';
import validatePackingCommand from '@/api/Carrier/validatePackingCommand';

import getFileLabelAddress from './getFileLabelAddress';
import getFileLabels from './getFileLabels';
import getFileShippingsQuery from './getFileShippingsQuery';
import getGenericCarrierAccountsDefinitionsQuery from './getGenericCarrierAccountsDefinitionsQuery';
import getGenericCarrierAccountsForUpsQuery from './getGenericCarrierAccountsForUpsQuery';
import getPricingForGenericCarrierAccountQuery from './getPricingForGenericCarrierAccountQuery';
import getShippingLabelQuery from './getShippingLabelQuery';
import listExternalCarrierCompanysQuery from './listExternalCarrierCompanysQuery';
import setDeleteAccountCarrier from './setDeleteAccountCarrier';
import setFileLabelAddress from './setFileLabelAddress';
import upsertGenericCarrierAccountForUpsCommand from './upsertGenericCarrierAccountForUpsCommand';
import upsertPricingForGenericCarrierAccountCommand from './upsertPricingForGenericCarrierAccountCommand';
import verifyAddress from './verifyAddress';

export const CarrierService = {
  getPickupPointByGeoCoordQuery:
    CommonCarrierService.getPickupPointByGeoCoordQuery,
  verifyAddress,
  getFileLabelAddress,
  getFileLabels,
  setFileLabelAddress,
  createHomePickupCommand: CommonCarrierService.createHomePickupCommand,
  getFileShippingsQuery,
  getGenericCarrierAccountsForUpsQuery,
  getGenericCarrierAccountsDefinitionsQuery,
  upsertGenericCarrierAccountForUpsCommand,
  listExternalCarrierCompanysQuery,
  getTransportPlanByIdQuery: CommonCarrierService.getTransportPlanByIdQuery,
  upsertPricingForGenericCarrierAccountCommand,
  getPricingForGenericCarrierAccountQuery,
  getShippingLabelQuery,
  setDeleteAccountCarrier,
  getWaitingPackingProductsBySellerQuery,
  getPackingBySellerByStatusQuery,
  getCarrierDimensionSpecificationsQuery,
  getCarrierLabelUrlByPackingParcelIdQuery,
  createPackingCommand,
  validatePackingCommand,
  uploadExternalCarrierDepositLabelCommand,
};
